import * as ReqType from '../types/ServerRequests';
import { AdresseService } from './AdresseService';
import Axios from 'axios';
import LoginServices from './LoginServices';
import { ResponsableService } from './ResponsableService';
/**
 * Cette classe permet la communication entre le backend et le frontend
 * Elle assure l'envois la reception des données entre le backend et frontend
 * Elle permet la creation, modification, et suppression d'un profil utilisateur
 */
export class UserProfileService {
    private static instance: UserProfileService = new UserProfileService();

    public static getInstance(): UserProfileService {
        return this.instance;
    }

    /**
     * modification et mis a jour d'un profil
     * @param {ProfileInfo} newProfil
     * @param {ProfileInfo} oldProfil
     * @returns {Promise<ProfileInfo>}
     */
    public updateProfil(
        newProfil: ReqType.ProfileInfo,
        oldProfil: ReqType.ProfileInfo
    ): Promise<ReqType.ProfileInfo> {
        const token = LoginServices.getInstance().getUserToken();
        return (Promise.all([
            AdresseService.getInstance().updateAdresse(newProfil.adresse, oldProfil.adresse),
            this.getResponsablePromise(newProfil, oldProfil),
        ]).then(
            (array) => {
                var adresse: ReqType.Adresse = array[0];
                var responsable: ReqType.Responsable | null = array[1];
                var monProfil = {
                    adresse_id: (adresse === null) ? null : adresse.id,
                    date_naissance: newProfil.date_naissance,
                    nom: newProfil.nom,
                    photo_profil: 'toto',
                    pointure: newProfil.pointure,
                    prenom: newProfil.prenom,
                    responsable_id: (responsable === null) ? null : responsable.id,
                    taille: newProfil.taille,
                    telephone: newProfil.telephone,
                };
                return (Axios.put(
                    process.env.REACT_APP_PROFIL_UPDATE_URL! + '&id=' + oldProfil.id,
                    monProfil,
                    {
                        headers: { 'X-Access-Token': token },
                    }
                ).then(
                    (response) => {
                        newProfil.adresse = adresse;
                        newProfil.responsable = responsable;
                        return newProfil;
                    }
                ));
            }
        ));
    }

    /**
     * creation d'un profil
     * @param {ProfileInfo} newProfil
     * @returns {Promise<ProfileInfo>}
     */
    public createProfil(newProfil: ReqType.ProfileInfo): Promise<ReqType.ProfileInfo> {
        const token = LoginServices.getInstance().getUserToken();
        return (
            Promise.all([
                AdresseService.getInstance().createAdresse(newProfil.adresse),
                this.getResponsablePromise(newProfil),
            ]).then(
                (array) => {
                    var adresse: ReqType.Adresse = array[0];
                    var responsable: ReqType.Responsable | null = array[1];
                    var monEvent = {
                        adresse_id: (adresse === null) ? null : adresse.id,
                        date_naissance: newProfil.date_naissance,
                        nom: newProfil.nom,
                        photo_profil: 'toto',
                        pointure: newProfil.pointure,
                        prenom: newProfil.prenom,
                        responsable_id: (responsable === null) ? null : responsable.id,
                        taille: newProfil.taille,
                        telephone: newProfil.telephone,
                    };
                    return (Axios.post(
                        process.env.REACT_APP_PROFILE_CREATE_URL!,
                        monEvent,
                        {
                            headers: { 'X-Access-Token': token },
                        }
                    ).then(
                        (response) => {
                            newProfil.id = response.data.id;
                            newProfil.adresse = adresse;
                            return newProfil;
                        }
                    ));
                }
            )
        );
    }

    /**
     * retourne le responsable d'un profile
     * @param {ProfileInfo} newProfil
     * @param {ProfileInfo} oldProfil
     * @returns {Promise<Responsable> | Promise<null>}
     */
    private getResponsablePromise(
        newProfil: ReqType.ProfileInfo,
        oldProfil?: ReqType.ProfileInfo
    ): Promise<ReqType.Responsable> | Promise<null> {
        if (newProfil.responsable === null) {
            return Promise.resolve(null);
        } else if (oldProfil === undefined || oldProfil.responsable === null) {
            return (ResponsableService.getInstance().createResponsable(newProfil.responsable));
        } else {
            return (ResponsableService.getInstance().updateResponsable(newProfil.responsable, oldProfil.responsable));
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/UserProfileService.tsx